// test710
(710 && 0);
